const resource = 'vehicles'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  getVariants(id, params) {
    return $axios.$get(`/${resource}/${id}/vehicle_variants`, { params })
  },
  fetchVehicleSearchVehicles(vehicleTypeId, brandId) {
    return $axios.$get('/v2/vehicle-search/vehicles', {
      params: { vehicle_type_id: vehicleTypeId, brand_id: brandId },
    })
  },
  fetchByRegistration(registration, country = 'fr') {
    return $axios.$get('/v2/vehicle-search/by-registration', {
      params: { registration, country },
    })
  },
  fetchSiteSearchVehicles(q) {
    return $axios.$get('/v2/site-search/vehicles', { params: { q } })
  },
  fetchVehicleSearchPage(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}`)
  },
  fetchVehicleSearchPageProducts(vehicleId, params) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/products`, { params })
  },
  fetchVehicleSearchPageFilters(vehicleId, params) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/filters`, { params })
  },
  fetchVehicleSearchPageRelatedVehicles(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/related-vehicles`)
  },
  fetchVehicleSearchPageHeadlights(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/headlights`)
  },
  fetchVehicleSearchPageHeadlightSummary(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/headlight-summary`)
  },
  fetchErrorPageRecommendedVehicles(params) {
    return $axios.$get('/v2/error-page/recommended-vehicles', { params })
  },
  fetchSitemapVehicles(params) {
    return $axios.$get('/v2/sitemap/vehicles', { params })
  },
  fetchHeadlightExcludedProducts(vehicleId, params) {
    return $axios.$get(`/v2/admin/vehicles/${vehicleId}/headlight-exclusions`, {
      params,
    })
  },
  excludeHeadlightProduct(vehicleId, data) {
    return $axios.$post(
      `/v2/admin/vehicles/${vehicleId}/headlight-exclusions`,
      data
    )
  },
  restoreHeadlightProduct(vehicleId, productId, params) {
    return $axios.$delete(
      `/v2/admin/vehicles/${vehicleId}/headlight-exclusions/${productId}`,
      { params }
    )
  },
  pinHeadlightHero(vehicleId, data) {
    return $axios.$post(`/v2/admin/vehicles/${vehicleId}/headlight-hero`, data)
  },
  unpinHeadlightHero(vehicleId, params) {
    return $axios.$delete(`/v2/admin/vehicles/${vehicleId}/headlight-hero`, {
      params,
    })
  },

  getServiceName: name => 'vehicleService',
})
